import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import EventCard from "@/components/feature/EventCard";
import { categories } from "@/mocks/site";
import { events } from "@/mocks/events";
import { getLatestEvents } from "@/lib/events";

function heatValue(heat: string): number {
  return parseFloat(heat.replace(/[^\d.]/g, "")) || 0;
}

export default function LatestReview() {
  const latest = getLatestEvents(4);
  const ranking = [...events].sort((a, b) => heatValue(b.heat) - heatValue(a.heat)).slice(0, 5);

  return (
    <section className="bg-background-100 py-16 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-8">
        <SectionHeading
          eyebrow="最新复盘"
          title="最近更新的事件梳理"
          desc="按发布时间排列，标注热度与当前状态，方便你判断哪些还在持续发酵。"
        />

        <div className="mt-9 grid gap-10 lg:grid-cols-12">
          <div className="flex flex-col gap-6 lg:col-span-8">
            {latest.map((event, index) => (
              <EventCard key={event.slug} event={event} layout="horizontal" order={index} />
            ))}
          </div>

          <aside className="lg:col-span-4">
            <div className="lg:sticky lg:top-24">
              <div className="rounded-lg border border-background-200 bg-background-50 p-6">
                <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
                  <i className="ri-fire-fill text-primary-500"></i>
                  热度榜
                </h3>
                <ol className="mt-5 space-y-4">
                  {ranking.map((event, index) => (
                    <li key={event.slug} className="flex gap-3">
                      <span
                        className={`flex h-6 w-6 shrink-0 items-center justify-center rounded text-xs font-medium ${
                          index < 3
                            ? "bg-primary-500 text-background-50"
                            : "bg-background-200 text-foreground-600"
                        }`}
                      >
                        {index + 1}
                      </span>
                      <div className="min-w-0">
                        <Link
                          to={`/events/${event.slug}`}
                          className="line-clamp-2 text-sm leading-6 text-foreground-800 transition-colors hover:text-primary-600"
                        >
                          {event.title}
                        </Link>
                        <span className="mt-1 block text-xs text-foreground-400">
                          {event.categoryName} · {event.heat}
                        </span>
                      </div>
                    </li>
                  ))}
                </ol>
              </div>

              <div className="mt-6 rounded-lg border border-background-200 bg-background-50 p-6">
                <h3 className="font-heading text-base font-bold text-foreground-950">快速分类</h3>
                <div className="mt-4 flex flex-wrap gap-2">
                  {categories.map((category) => (
                    <Link
                      key={category.slug}
                      to={`/events?category=${category.slug}`}
                      className="rounded-full bg-secondary-100 px-3 py-1.5 text-xs text-secondary-900 transition-colors hover:bg-secondary-200"
                    >
                      {category.name}
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}